import emailjs from '@emailjs/browser';
import React from "react";
import { toast } from 'react-hot-toast';
import { Fade } from "react-reveal";
// import {ReactComponent as AnimatedImage }from '../../Assets/Animations/live-collaboration-animate.svg'
import contactMeImage from '../../Assets/Animations/Face to face.gif'
import SocialMediaConnection from '../AboutMe/SocialMediaConnection';

const ContactMe = () => {
  const formHandler = (event) => {
    event.preventDefault()
    const form = event.target
    const name = form.name.value
    const email = form.email.value
    const message = form.message.value

    const templateParams = {
      from_name: email,
      to_name: name,
      message,
    }

    emailjs.send(`${process.env.REACT_APP_SERVICE_ID}`, `${process.env.REACT_APP_TEMPLATE_ID}`, templateParams, `${process.env.REACT_APP_PublicKey}`)
      .then(function (response) {
        toast.success("Thanks You, I’ll be in touch")
      }, function (error) {
        console.log('FAILED...', error);
      });

  }
  return (
    <div className="py-10   bg-gradient-to-r from-gray-900 to-transparent">
      <div className=' md:flex  px-10 md:px-20 container mx-auto'>
        {/* Animated Image  */}
        <div className=' h-96 mx-auto md:mx-10'>
          <Fade left>
            <img className=' h-96 w-full' src={contactMeImage} alt="contactMeImage" />
          </Fade>
          <SocialMediaConnection></SocialMediaConnection>
        </div>

        {/* form  */}
        <form onSubmit={formHandler} className="w-full max-w-lg ">
          <Fade right>
            <div className="flex flex-wrap -mx-3 mt-32 md:mt-0">
              <div className='mb-10 mx-auto md:mx-3'><h1 className='text-3xl font-bold '>Let's Connect</h1></div>
              <div className="w-full px-3">
                <Fade right cascade delay={700}>
                  <label
                    className="block uppercase tracking-wide text-primary text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Name
                  </label>
                </Fade>
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="nick"
                  type="text"
                  name="name"
                />

              </div>
            </div>
          </Fade>
          <Fade left>
            <div className="flex flex-wrap -mx-3 mb-4">
              <div className="w-full px-3">
                <Fade left cascade delay={1300}>
                  <label
                    className="block uppercase tracking-wide text-primary text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    E-mail
                  </label>
                </Fade>
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="email"
                  type="email"
                  name="email"
                />

              </div>
            </div>
          </Fade>
          <Fade bottom>
            <div className="flex flex-wrap -mx-3 mb-4">
              <div className="w-full px-3">
                <Fade left cascade delay={1600}>
                  <label
                    className="block uppercase tracking-wide text-primary text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Message
                  </label>
                </Fade>
                <textarea
                  className=" no-resize appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-48 resize-none"
                  id="message"
                  name="message"
                ></textarea>

              </div>
            </div>
          </Fade>
          <div className="md:flex md:items-center">
            <div className="md:w-1/3">
              <Fade right>
                <button
                  className="shadow bg-primary hover:bg-teal-900 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                  type="submit"
                >
                  Send
                </button>
              </Fade>
            </div>
            <div className="md:w-2/3"></div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactMe;
